import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const NotAuthenticatedRoute = ({ match, component: Component, isAuthenticated, eulaExpired, ...routeParams }) => {
	const inviteCode = routeParams?.computedMatch?.params?.inviteCode;
	const email = routeParams?.computedMatch?.params?.email;
	const redirectToHome = !routeParams.location.pathname.includes('/callback/signin') && !routeParams.location.pathname.includes('/onboarding') && isAuthenticated
	const to = inviteCode ? "/invite/" + inviteCode + '/' + email : "/overview"
	
	return (
		<Route
			{...routeParams}
			render={props => redirectToHome ? <Redirect to={to + props.location.search || ''} /> : <Component {...props}/>}
		/>
	)
};

const mapStateToProps = ({ session }) => ({
	isAuthenticated: session.isAuthenticated,
	eulaExpired: session.eulaExpired
});

NotAuthenticatedRoute.propTypes = {};

export default connect(mapStateToProps)(NotAuthenticatedRoute);
